
import Map from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

import * as olProj from 'ol/proj';

import TileLayer from 'ol/layer/Tile';

import VectorSource from 'ol/source/Vector';

import VectorLayer from 'ol/layer/Vector';

import { defaults as defaultControls, FullScreen } from 'ol/control';

import { BingMaps } from 'ol/source';

import { MapService } from 'src/app/services/map.service';

import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute } from '@angular/router';

import { AccountService } from 'src/app/services/account.service';

import { OtherService } from 'src/app/services/other.service';
import { MapBuilderService } from 'src/app/services/map-builder.service';

@Component({

  selector: 'app-route',

  templateUrl: './route.component.html',

  styleUrls: ['./route.component.css']

})
export class RouteComponent implements OnInit {

  source: any;

  vector: any;

  layers: any = [];

  map: any = {};

  mdl_Route: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this._otherService.getLocalStorage().Id),

    strSession: new FormControl(this._otherService.getLocalStorage().session),

    iEmdadRo: new FormControl(''),

  });

  constructor(
    private route: ActivatedRoute,
    private _otherService: OtherService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private mapService: MapService,
    private mapBuilderService: MapBuilderService,
  ) { }

  ngOnInit(): void {

    this.route.paramMap.subscribe((data: any) => {

      this.mdl_Route.patchValue({

        iEmdadRo: data.params.id

      })

    })

    this.accountService.EmdadRo_Route(this._otherService.stringNumberToNumber(this.mdl_Route.value)).subscribe((res) => {

      this.mapService.drawRouteFull('fullRoute', this.map, res, 'Hello');

      this.fitMap(res);

    })

    setTimeout(() => {

      this.newOpenMap();

    }, 100);

  }

  newOpenMap() {

    this.source = new VectorSource({ wrapX: false });

    this.vector = new VectorLayer({

      source: this.source,

    });

    const styles = [

      'AerialWithLabelsOnDemand',

    ];

    let i, ii;

    for (i = 0, ii = styles.length; i < ii; ++i) {

      this.layers.push(

        new TileLayer({

          visible: false,

          preload: Infinity,

          source: new BingMaps({

            key: 'AnyK3Znr5dGRC7QqdZpTT3vbxpdcxPWB5ehWfJYf9k1Iq-b-jZrYKiX1NkSLKNi-',

            imagerySet: styles[i],

          }),

        }),

      );

    }

    this.layers.push(new TileLayer({

      source: new OSM({}),

    }), this.vector)


    this.map = this.mapBuilderService.createMap('test', [51.3833554, 35.6770113]);

  }

  fitMap(data?: any) {

    if (data.length > 1) {

      var view = this.map.getView();

      var maxLatitude = Math.max.apply(Math,

        data.map(function (o: any) {

          return o.fLat;

        }));

      var maxLongitude = Math.max.apply(Math,

        data.map(function (o: any) {

          return o.fLon;

        }));

      var minLatitude = Math.min.apply(Math,

        data.map(function (o: any) {

          return o.fLat;

        }));

      var minLongitude = Math.min.apply(Math,

        data.map(function (o: any) {

          return o.fLon;

        })

      );

      var transformedStart = this.mapService.transformCoordinates2([

        maxLongitude,

        maxLatitude,

      ]);

      var transformedEnd = this.mapService.transformCoordinates2([

        minLongitude,

        minLatitude,

      ]);

      var source = [

        Math.min(transformedStart[0], transformedEnd[0]) - 2000,

        Math.min(transformedStart[1], transformedEnd[1]) - 2000,

        Math.max(transformedStart[0], transformedEnd[0]) + 2000,

        Math.max(transformedStart[1], transformedEnd[1]) + 2000,

      ];

      view.fit(source);

    }
  }

}
